import { Map } from 'immutable';

import { ABOUT_OPERATIONS } from '../../../../constants/product';

export function about({ preview }) {
  function reduceAboutPreview(result, value, type) {
    result.push(Map({ type: ABOUT_OPERATIONS[type], value }));
    return result;
  }

  return { payload: preview.get('about').reduce(reduceAboutPreview, []) };
}
